<section class="tenant-registration mx-auto w-full max-w-[1450px] px-2 pb-8 pt-14 sm:px-6 lg:px-10">
  <div class="rounded-md px-6 py-8 sm:px-10 lg:px-12">
    <div class="mb-6 flex justify-end">
      <a routerLink="/login" class="tenant-btn tenant-btn-secondary min-w-[140px] justify-center">
        <i class="fa fa-arrow-left"></i>
        Back to Login
      </a>
    </div>

    <div class="mb-10 text-center">
      <h1 class="text-2xl font-extrabold uppercase tracking-normal text-[#0f2948] dark:text-white sm:text-3xl">New Tenant Registration</h1>

      <nav class="mt-9 flex flex-col items-start justify-center gap-4 text-sm font-bold sm:flex-row sm:items-center sm:gap-5 md:text-base">
        @for (step of steps; track step.id; let last = $last) {
        <button
          type="button"
          class="group flex items-center gap-3 text-left"
          [class.cursor-default]="step.id > currentStep"
          [class.cursor-pointer]="step.id <= currentStep"
          (click)="goToStep(step.id)"
        >
          <span
            class="grid h-8 w-8 place-content-center rounded-full text-sm font-extrabold transition"
            [ngClass]="step.id <= currentStep ? 'bg-[#9a0000] text-white' : 'bg-[#e8edf3] text-[#607088]'"
          >
            {{ step.id }}
          </span>
          <span [ngClass]="step.id <= currentStep ? 'text-[#9a0000]' : 'text-[#8b9bb5]'">{{ step.label }}</span>
        </button>

        @if (!last) {
        <div class="hidden h-px w-16 bg-[#cbd5e1] sm:block">
          <span class="block h-px w-full" [ngClass]="step.id < currentStep ? 'bg-[#9a0000]' : 'bg-[#cbd5e1]'"></span>
        </div>
        } }
      </nav>
    </div>

    <div class="grid gap-8 xl:grid-cols-[350px_minmax(0,1fr)] xl:gap-10">
      <aside class="rounded-md border border-[#dce4ee] bg-[#f8fafc] p-7 dark:border-[#253b5c] dark:bg-[#111c2d]">
        <h2 class="text-xl font-extrabold text-[#07182f] dark:text-white">Create Your Workspace</h2>
        <div class="mt-5 h-px bg-[#dce4ee] dark:bg-[#253b5c]"></div>

        <div class="mt-6 space-y-6">
          <div class="flex gap-4">
            <span class="mt-1 grid h-5 w-5 shrink-0 place-content-center rounded-full bg-[#9a0000] text-[10px] text-white">
              <i class="fa fa-check"></i>
            </span>
            <div>
              <h3 class="text-base font-extrabold text-[#163154] dark:text-white">Your Admin Account</h3>
              <p class="mt-2 max-w-[230px] text-sm leading-6 text-[#516785] dark:text-white-dark">
                Enter the details for the person who will manage this workspace.
              </p>
            </div>
          </div>

          <div class="flex gap-4">
            <span class="mt-1 grid h-5 w-5 shrink-0 place-content-center text-[#9a0000]">
              <i class="fa fa-building text-lg"></i>
            </span>
            <div>
              <h3 class="text-base font-extrabold text-[#163154] dark:text-white">Company Details</h3>
              <p class="mt-2 max-w-[245px] text-sm leading-6 text-[#516785] dark:text-white-dark">
                Add your business information now. You can create additional companies after setup.
              </p>
            </div>
          </div>
        </div>
      </aside>

      <form class="min-w-0" [formGroup]="tenantForm" (ngSubmit)="nextStep()">
        @if (currentStep === 1) {
        <div class="space-y-7">
          <section class="tenant-section">
            <div class="tenant-section-title">
              <i class="fa fa-user-shield text-[#9a0000]"></i>
              <h2>Tenant Info</h2>
            </div>

            <div class="grid gap-x-6 gap-y-6 md:grid-cols-2">
              <label class="tenant-field">
                <span>Tenant Name <b>*</b></span>
                <input type="text" formControlName="companyName" class="form-input" placeholder="e.g. RK Distributions" />
                @if (isInvalid('companyName')) {
                <small>Tenant name is required.</small>
                }
              </label>

              <label class="tenant-field">
                <span>No. of Companies <b>*</b></span>
                <input type="number" formControlName="noOfCompanies" class="form-input" min="1" max="5" />
                @if (isInvalid('noOfCompanies')) {
                <small>Enter a value between 1 and 5.</small>
                }
              </label>

              <label class="tenant-field">
                <span>First Name <b>*</b></span>
                <input type="text" formControlName="firstName" class="form-input" placeholder="e.g. Ravi" />
                @if (isInvalid('firstName')) {
                <small>First name is required.</small>
                }
              </label>

              <label class="tenant-field">
                <span>Last Name</span>
                <input type="text" formControlName="lastName" class="form-input" placeholder="e.g. Kumar" />
              </label>

              <label class="tenant-field">
                <span>Email Address <b>*</b></span>
                <input type="email" formControlName="email" class="form-input" placeholder="name@example.com" />
                @if (isInvalid('email')) {
                <small
                  >{{ tenantForm.controls.email.errors?.['emailExists'] ? 'An account with this email already exists.' : 'Enter a valid email address.' }}</small
                >
                }
              </label>

              <label class="tenant-field">
                <span>Password <b>*</b></span>
                <input type="password" formControlName="password" class="form-input" placeholder="Create password" />
                @if (isInvalid('password')) {
                <small>Password is required.</small>
                }
              </label>

              <label class="tenant-field">
                <span>Designation</span>
                <input type="text" formControlName="designation" class="form-input" placeholder="e.g. CEO / Director" />
              </label>

              <label class="tenant-field">
                <span>Mobile Number <b>*</b></span>
                <input type="tel" formControlName="mobileNumber" class="form-input" placeholder="Enter mobile number" />
                @if (isInvalid('mobileNumber')) {
                <small>{{ tenantForm.controls.mobileNumber.errors?.['required'] ? 'Mobile number is required.' : 'Enter a valid mobile number.' }}</small>
                }
              </label>

              <label class="tenant-field">
                <span>Country <b>*</b></span>
                <select formControlName="countryId" class="form-input">
                  <option [ngValue]="null">Select Country</option>
                  @for (country of countries; track country.id) {
                  <option [ngValue]="country.id">{{ country.name }}</option>
                  }
                </select>
                @if (isInvalid('countryId')) {
                <small>Country is required.</small>
                }
              </label>

              <label class="tenant-field">
                <span>Address</span>
                <textarea rows="2" formControlName="address" class="form-input" placeholder="Tenant or billing address"></textarea>
              </label>
            </div>
          </section>
        </div>
        } @if (currentStep === 2) {
        <div class="space-y-5" [formGroup]="companySetupForm">
          <div class="space-y-4 pr-1" formArrayName="companies">
            @for (company of companies.controls; track company; let i = $index) {
            <div
              class="rounded-md border bg-white shadow-sm dark:bg-[#0e1726]"
              [class.overflow-hidden]="openCurrencyPickerIndex !== i"
              [class.overflow-visible]="openCurrencyPickerIndex === i"
              [ngClass]="companyHasVisibleError(i) ? 'border-[#9a0000] dark:border-[#9a0000]' : 'border-[#dce4ee] dark:border-[#253b5c]'"
              [formGroupName]="i"
            >
              <div class="flex items-center justify-between gap-3 border-b border-[#dce4ee] bg-[#f8fafc] px-4 py-3 dark:border-[#253b5c] dark:bg-[#111c2d]">
                <button type="button" class="flex min-w-0 items-center gap-2 text-left" (click)="toggleCompany(i)">
                  <i class="fa fa-building text-[#9a0000]"></i>
                  @if (tenantForm.controls.companyName.value) {
                  <span
                    class="shrink-0 rounded-full border border-[#dce4ee] bg-[#eef2f6] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-[#607088] dark:border-[#253b5c] dark:bg-[#1b2a43] dark:text-white-dark"
                  >
                    Tenant : {{ tenantForm.controls.companyName.value }}
                  </span>
                  }
                  <span class="truncate text-sm font-extrabold text-[#163154] dark:text-white">{{ companyTitle(i) }}</span>
                  @if (company.get('isPrimary')?.value) {
                  <span class="rounded-full border border-[#f0d5d5] bg-[#fff7f7] px-2 py-0.5 text-[10px] font-extrabold text-[#9a0000]">PRIMARY</span>
                  } @if (companyHasVisibleError(i)) {
                  <span class="rounded-full bg-[#9a0000] px-2 py-0.5 text-[10px] font-extrabold text-white">NEEDS ATTENTION</span>
                  }
                </button>

                <div class="flex items-center gap-3">
                  @if (i !== 0) {
                  <button type="button" class="text-[#8a9ab4] hover:text-[#9a0000]" title="Delete Company" (click)="deleteCompany(i)">
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                  }
                  <button type="button" class="text-[#8a9ab4] hover:text-[#163154]" (click)="toggleCompany(i)">
                    <i class="fa fa-chevron-down transition-transform" [ngClass]="{ 'rotate-180': company.get('isOpen')?.value }"></i>
                  </button>
                </div>
              </div>

              @if (company.get('isOpen')?.value) {
              <div class="grid gap-x-5 gap-y-4 p-4 md:grid-cols-2">
                <label class="tenant-field md:col-span-2">
                  <span>Company Name <b>*</b></span>
                  <input type="text" formControlName="name" class="form-input" placeholder="e.g. RK Distributions" />
                  @if (companyInvalid(i, 'name')) {
                  <small>Company name is required.</small>
                  }
                </label>

                <label class="tenant-field">
                  <span>Trade Name</span>
                  <input type="text" formControlName="tradeName" class="form-input" placeholder="e.g. RK Trade" />
                </label>

                <label class="tenant-field">
                  <span>Corporate Email</span>
                  <input type="email" formControlName="corporateEmail" class="form-input" placeholder="e.g. corp@rkdist.co" />
                  @if (companyInvalid(i, 'corporateEmail')) {
                  <small>Enter a valid corporate email.</small>
                  }
                </label>

                <label class="tenant-field">
                  <span>Tax Registration Number</span>
                  <input type="text" formControlName="taxRegistrationNumber" class="form-input" placeholder="e.g. GSTIN91606390" />
                </label>

                <label class="tenant-field">
                  <span>Registration Number</span>
                  <input type="text" formControlName="registrationNumber" class="form-input" placeholder="Company registration number" />
                </label>

                <label class="tenant-field">
                  <span>Mobile No.</span>
                  <input type="tel" formControlName="mobileNo" class="form-input" placeholder="Company mobile number" />
                  @if (companyInvalid(i, 'mobileNo')) {
                  <small>Enter a valid mobile number.</small>
                  }
                </label>

                <label class="tenant-field">
                  <span>Website</span>
                  <input type="url" formControlName="website" class="form-input" placeholder="https://example.com" />
                </label>

                <label class="tenant-field logo-upload-field">
                  <span>Logo</span>
                  <input type="file" class="sr-only" accept="image/*" (change)="onCompanyLogoChange(i, $event)" />
                  <span class="logo-upload-box">
                    @if (logoPreviewUrls[i]) {
                    <img [src]="logoPreviewUrls[i]" alt="Company logo preview" />
                    } @else {
                    <i class="fa fa-image"></i>
                    }
                    <span class="logo-upload-copy">
                      <strong>{{ companyLogoFileName(i) || 'Choose logo image' }}</strong>
                      <small>PNG, JPG, JPEG, or WebP</small>
                    </span>
                  </span>
                </label>

                <label class="tenant-field">
                  <span>Country <b>*</b></span>
                  <select formControlName="countryId" class="form-input">
                    <option [ngValue]="null">Select Country</option>
                    @for (country of countries; track country.id) {
                    <option [ngValue]="country.id">{{ country.name }}</option>
                    }
                  </select>
                  @if (companyInvalid(i, 'countryId')) {
                  <small>Country is required.</small>
                  }
                </label>

                <label class="tenant-field">
                  <span>Business Type</span>
                  <select formControlName="businessTypeId" class="form-input">
                    <option [ngValue]="null">Select Business Type</option>
                    @for (type of businessTypes; track type.id) {
                    <option [ngValue]="type.id">{{ type.name }}</option>
                    }
                  </select>
                </label>

                <label class="tenant-field">
                  <span>Employee Size</span>
                  <select formControlName="employeeSizeId" class="form-input">
                    <option [ngValue]="null">Select Size Range</option>
                    @for (size of employeeSizes; track size.id) {
                    <option [ngValue]="size.id">{{ size.name }}</option>
                    }
                  </select>
                </label>

                <label class="tenant-field md:col-span-2">
                  <span>Address</span>
                  <textarea formControlName="address" class="form-input min-h-[82px]" placeholder="Company address"></textarea>
                </label>

                <section class="rounded-md border border-[#dce4ee] bg-[#f8fafc] p-4 dark:border-[#253b5c] dark:bg-[#111c2d] md:col-span-2">
                  <div class="mb-4 flex flex-col gap-1 border-b border-[#dce4ee] pb-3 dark:border-[#253b5c]">
                    <div class="flex items-center gap-2">
                      <i class="fa-solid fa-coins text-[#9a0000]"></i>
                      <h3 class="text-sm font-extrabold text-[#163154] dark:text-white">Currency Setup</h3>
                    </div>
                    <p class="text-[11px] font-medium text-[#607088] dark:text-white-dark">
                      Choose the currencies available to this company and select its default currency.
                    </p>
                  </div>

                  @if (currencies.length) {
                  <div class="grid gap-4 lg:grid-cols-[minmax(0,1fr)_260px]">
                    <div class="min-w-0">
                      <div class="mb-2 flex items-center justify-between gap-3">
                        <span class="text-[11px] font-extrabold uppercase tracking-wide text-[#607088] dark:text-white-dark">Selected currencies</span>
                        <span
                          class="rounded-full bg-white px-2.5 py-1 text-[10px] font-extrabold text-[#607088] shadow-sm dark:bg-[#0e1726] dark:text-white-dark"
                        >
                          {{ selectedCurrencies(i).length }} selected
                        </span>
                      </div>

                      <div class="min-h-[46px] rounded-md border border-[#dce4ee] bg-white p-2 dark:border-[#253b5c] dark:bg-[#0e1726]">
                        <div class="flex flex-wrap gap-2">
                          @for (currency of selectedCurrencies(i); track currency.id) {
                          <span
                            class="inline-flex max-w-full items-center gap-2 rounded-full border border-[#efcaca] bg-[#fffafa] px-3 py-1.5 text-xs font-bold text-[#163154] dark:border-[#53303a] dark:bg-[#1b1018] dark:text-white"
                          >
                            <span class="font-extrabold text-[#9a0000]">{{ currency.code }}</span>
                            <span class="max-w-[135px] truncate text-[#607088] dark:text-white-dark">{{ currency.name }}</span>
                            @if (isDefaultCurrency(i, currency.id)) {
                            <span class="rounded-full bg-[#9a0000] px-1.5 py-0.5 text-[8px] font-extrabold uppercase text-white">Default</span>
                            }
                            <button
                              type="button"
                              class="text-[#8a9ab4] transition hover:text-[#9a0000]"
                              title="Remove currency"
                              (click)="removeCurrency(i, currency.id)"
                            >
                              <i class="fa-solid fa-xmark"></i>
                            </button>
                          </span>
                          } @empty {
                          <span class="px-1 py-1.5 text-xs font-semibold text-[#8a9ab4]">No currencies selected.</span>
                          }
                        </div>
                      </div>

                      <div data-currency-picker class="relative mt-3">
                        <button
                          type="button"
                          class="flex w-full items-center justify-between rounded-md border border-[#cbd5e1] bg-white px-3 py-2.5 text-left text-sm font-bold text-[#163154] transition hover:border-[#9a0000] dark:border-[#253b5c] dark:bg-[#0e1726] dark:text-white"
                          (click)="toggleCurrencyPicker(i)"
                        >
                          <span class="flex items-center gap-2">
                            <i class="fa-solid fa-coins text-[#9a0000]"></i>
                            Choose currencies
                          </span>
                          <i
                            class="fa-solid fa-chevron-down text-xs text-[#8a9ab4] transition-transform"
                            [class.rotate-180]="openCurrencyPickerIndex === i"
                          ></i>
                        </button>

                        @if (openCurrencyPickerIndex === i) {
                        <div
                          class="absolute left-0 right-0 top-full z-[90] mt-2 overflow-hidden rounded-md border border-[#cbd5e1] bg-white shadow-xl dark:border-[#253b5c] dark:bg-[#0e1726]"
                        >
                          <div class="border-b border-[#e5eaf0] p-3 dark:border-[#253b5c]">
                            <div class="relative">
                              <i class="fa-solid fa-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-xs text-[#8a9ab4]"></i>
                              <input
                                type="search"
                                class="form-input pl-9"
                                placeholder="Search by code, name, or symbol..."
                                [value]="currencySearches[i] || ''"
                                (input)="updateCurrencySearch(i, $any($event.target).value)"
                              />
                            </div>
                          </div>
                          <div class="max-h-52 overflow-y-auto p-2">
                            @for (currency of filteredCurrencies(i); track currency.id) {
                            <label
                              class="flex cursor-pointer items-center justify-between gap-3 rounded px-3 py-2 transition hover:bg-[#f8fafc] dark:hover:bg-[#111c2d]"
                            >
                              <span class="flex min-w-0 items-center gap-3">
                                <input
                                  type="checkbox"
                                  class="form-checkbox shrink-0 bg-white dark:bg-black"
                                  [checked]="isCurrencySelected(i, currency.id)"
                                  (change)="toggleCurrency(i, currency.id, $any($event.target).checked)"
                                />
                                <span class="min-w-0">
                                  <strong class="block text-xs text-[#163154] dark:text-white"
                                    >{{ currency.code }}{{ currency.symbol ? ' · ' + currency.symbol : '' }}</strong
                                  >
                                  <small class="block truncate text-[10px] text-[#607088] dark:text-white-dark">{{ currency.name }}</small>
                                </span>
                              </span>
                              @if (isCurrencySelected(i, currency.id)) {
                              <i class="fa-solid fa-check text-xs text-[#9a0000]"></i>
                              }
                            </label>
                            } @empty {
                            <div class="px-3 py-6 text-center text-xs font-semibold text-[#8a9ab4]">No matching currencies found.</div>
                            }
                          </div>
                          <div
                            class="flex items-center justify-between border-t border-[#e5eaf0] bg-[#f8fafc] px-3 py-2 dark:border-[#253b5c] dark:bg-[#111c2d]"
                          >
                            <span class="text-[10px] font-bold text-[#607088] dark:text-white-dark">{{ selectedCurrencies(i).length }} selected</span>
                            <button
                              type="button"
                              class="rounded px-3 py-1.5 text-xs font-extrabold text-[#9a0000] hover:bg-[#fff0f0]"
                              (click)="closeCurrencyPicker()"
                            >
                              Done
                            </button>
                          </div>
                        </div>
                        }
                      </div>
                      @if (companyInvalid(i, 'currencyIds')) {
                      <p class="mt-2 text-xs font-bold text-[#9a0000]">Select at least one currency for this company.</p>
                      }
                    </div>

                    <label class="tenant-field self-start">
                      <span>Default Currency <b>*</b></span>
                      <select class="form-input" formControlName="defaultCurrencyId" (change)="onDefaultCurrencyChange(i, $any($event.target).value)">
                        <option value="">Select Default Currency</option>
                        @for (currency of selectedCurrencies(i); track currency.id) {
                        <option [value]="currency.id">{{ currency.code }} - {{ currency.name }}</option>
                        }
                      </select>
                      @if (companyInvalid(i, 'defaultCurrencyId')) {
                      <small>Select one default currency.</small>
                      } @else {
                      <small class="!mt-2 !block !text-[#607088] dark:!text-white-dark">The default currency starts with an exchange rate of 1.</small>
                      }
                    </label>
                  </div>
                  } @else {
                  <div class="rounded-md border border-[#fde2a8] bg-[#fffbeb] px-4 py-3 text-xs font-bold text-[#7c4a03]">
                    Currency options are not available. Please try again.
                  </div>
                  }
                </section>

                <label
                  class="flex cursor-pointer items-center gap-3 rounded-md border border-[#f0d5d5] bg-[#fff7f7] p-3 text-xs font-bold text-[#7a1010] dark:border-[#3b2633] dark:bg-[#1b1018] dark:text-white-dark"
                >
                  <input
                    type="checkbox"
                    formControlName="isPrimary"
                    class="form-checkbox bg-white dark:bg-black"
                    (change)="selectPrimaryCompany(i, $any($event.target).checked)"
                  />
                  <span class="flex items-center gap-2">
                    <i class="fa fa-star text-[#9a0000]"></i>
                    Primary company
                  </span>
                </label>
              </div>
              }
            </div>
            }
          </div>

          <button
            type="button"
            class="flex w-full items-center justify-center gap-2 rounded-md border-2 border-dashed border-[#9a0000] px-4 py-2 text-sm font-extrabold text-[#9a0000] transition hover:bg-[#fff7f7] disabled:cursor-not-allowed disabled:border-[#cbd5e1] disabled:bg-[#f8fafc] disabled:text-[#8a9ab4]"
            [disabled]="companies.length >= maxCompanies"
            (click)="addCompany()"
          >
            <i class="fa" [ngClass]="companies.length >= maxCompanies ? 'fa-triangle-exclamation' : 'fa-plus-circle'"></i>
            {{
              companies.length >= maxCompanies ? 'Configured company count reached.' : 'Add Another Company (' + companies.length + ' of ' + maxCompanies + ')'
            }}
          </button>
          @if (primaryCompanyInvalid()) {
          <p class="rounded-md border border-[#f0d5d5] bg-[#fff7f7] px-3 py-2 text-xs font-bold text-[#9a0000]">
            Please select one primary company before continuing.
          </p>
          } @if (companyCountInvalid()) {
          <p class="rounded-md border border-[#f0d5d5] bg-[#fff7f7] px-3 py-2 text-xs font-bold text-[#9a0000]">
            Please configure at least one company before continuing.
          </p>
          }
        </div>
        } @if (currentStep === 3 && !registrationSubmitted) {
        <div class="space-y-6">
          <div class="space-y-5">
            <section class="rounded-md border border-[#dce4ee] bg-[#f8fafc] p-4 shadow-sm dark:border-[#253b5c] dark:bg-[#111c2d]">
              <div class="flex items-center justify-between border-b border-[#dce4ee] pb-3 dark:border-[#253b5c]">
                <div class="flex items-center gap-2">
                  <h2 class="text-xs font-extrabold uppercase tracking-wide text-[#163154] dark:text-white">Tenant Information</h2>
                  <!--@if (tenantForm.controls.companyName.value) {
                  <span
                    class="rounded-full border border-[#dce4ee] bg-[#eef2f6] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-[#607088] dark:border-[#253b5c] dark:bg-[#1b2a43] dark:text-white-dark"
                  >
                    {{ tenantForm.controls.companyName.value }}
                  </span>
                  }-->
                </div>
                <button type="button" class="text-xs font-extrabold text-[#9a0000] hover:underline" (click)="goToStep(1)">Edit</button>
              </div>

              <div class="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 text-sm text-[#516785] dark:text-white-dark sm:grid-cols-3 lg:grid-cols-5">
                <div>
                  <span class="block text-[10px] font-extrabold uppercase text-[#8a9ab4]">Tenant Name</span>
                  <span class="font-semibold">{{ tenantForm.controls.companyName.value || '-' }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-extrabold uppercase text-[#8a9ab4]">Full Name</span>
                  <span class="font-bold text-[#163154] dark:text-white">{{ tenantDisplayName }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-extrabold uppercase text-[#8a9ab4]">Email</span>
                  <span class="break-all font-semibold">{{ tenantForm.controls.email.value || '-' }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-extrabold uppercase text-[#8a9ab4]">Country</span>
                  <span class="font-semibold">{{ tenantCountryName }}</span>
                </div>

                <div>
                  <span class="block text-[10px] font-extrabold uppercase text-[#8a9ab4]">Companies</span>
                  <span class="font-semibold">{{ tenantForm.controls.noOfCompanies.value || '-' }}</span>
                </div>
              </div>
            </section>

            <section class="rounded-md border border-[#dce4ee] bg-[#f8fafc] p-4 shadow-sm dark:border-[#253b5c] dark:bg-[#111c2d]">
              <div class="flex items-center justify-between border-b border-[#dce4ee] pb-3 dark:border-[#253b5c]">
                <h2 class="text-xs font-extrabold uppercase tracking-wide text-[#163154] dark:text-white">Configured Companies</h2>
                <button type="button" class="text-xs font-extrabold text-[#9a0000] hover:underline" (click)="goToStep(2)">Edit</button>
              </div>

              <div class="mt-4 max-h-[280px] space-y-3 overflow-y-auto pr-1">
                @for (company of companies.controls; track company; let i = $index) {
                <article class="rounded-md border border-[#dce4ee] bg-white p-3 text-xs dark:border-[#253b5c] dark:bg-[#0e1726]">
                  <div class="flex flex-col gap-2 border-b border-[#eef2f6] pb-2 dark:border-[#253b5c] sm:flex-row sm:items-center sm:justify-between">
                    <div class="flex min-w-0 items-center gap-2">
                      <i class="fa fa-building shrink-0 text-[#9a0000]"></i>
                      <span class="truncate font-extrabold text-[#163154] dark:text-white">{{ companyTitle(i) }}</span>
                      @if (company.get('isPrimary')?.value) {
                      <span class="rounded-full border border-[#f0d5d5] bg-[#fff7f7] px-2 py-0.5 text-[10px] font-extrabold text-[#9a0000]">PRIMARY</span>
                      }
                    </div>
                    <span class="w-max rounded bg-[#eef2f6] px-2 py-0.5 text-[10px] font-bold text-[#607088] dark:bg-[#1b2a43] dark:text-white-dark">
                      {{ company.get('code')?.value || 'NO CODE' }}
                    </span>
                  </div>

                  <div class="mt-3 grid gap-3 text-[#516785] dark:text-white-dark sm:grid-cols-4">
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Corp Email</span>
                      <span class="break-all font-semibold">{{ company.get('corporateEmail')?.value || '-' }}</span>
                    </div>
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Business Type</span>
                      <span class="font-semibold">{{ companyBusinessTypeName(i) }}</span>
                    </div>
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Employee Size</span>
                      <span class="font-semibold">{{ companyEmployeeSizeName(i) }}</span>
                    </div>
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Mobile</span>
                      <span class="font-semibold">{{ company.get('mobileNo')?.value || '-' }}</span>
                    </div>
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Currencies</span>
                      <span class="font-semibold">
                        @for (currency of selectedCurrencies(i); track currency.id; let last = $last) {
                        {{ currency.code }}{{ last ? '' : ', ' }}
                        }
                      </span>
                    </div>
                    <div>
                      <span class="block text-[9px] font-extrabold uppercase text-[#8a9ab4]">Default Currency</span>
                      <span class="font-semibold">{{ defaultCurrency(i)?.code || '-' }}</span>
                    </div>
                  </div>
                </article>
                }
              </div>
            </section>
          </div>

          <div>
            <label
              class="flex cursor-pointer items-start gap-3 text-xs leading-5 text-[#516785] dark:text-white-dark"
              [ngClass]="termsTouched && !termsAccepted ? 'text-[#9a0000]' : ''"
            >
              <input
                type="checkbox"
                class="form-checkbox mt-0.5 bg-white dark:bg-black"
                [checked]="termsAccepted"
                (change)="acceptTerms($any($event.target).checked)"
              />
              <span>
                By completing this registration process, you affirm all declared company profiles are legally owned and agree to the platform's standard SaaS
                Terms of Service.
              </span>
            </label>
            @if (termsTouched && !termsAccepted) {
            <p class="mt-2 text-xs font-bold text-[#9a0000]">Please accept the Terms of Service to complete registration.</p>
            } @if (submitError) {
            <p class="mt-2 rounded-md border border-[#f0d5d5] bg-[#fff7f7] px-3 py-2 text-xs font-bold text-[#9a0000]">
              {{ submitError }}
            </p>
            }
          </div>
        </div>
        } @if (registrationSubmitted) {
        <div class="flex min-h-[390px] flex-col items-center justify-center py-8 text-center">
          <div
            class="grid h-20 w-20 place-content-center rounded-full border-2 border-[#26a269] bg-[#eaf8f0] text-3xl text-[#198754] shadow-lg shadow-[#198754]/10"
          >
            <i class="fa fa-check-circle"></i>
          </div>
          <h2 class="mt-6 text-2xl font-extrabold text-[#0f2948] dark:text-white">Registration Successful!</h2>
          <p class="mt-2 max-w-lg text-sm text-[#516785] dark:text-white-dark">
            Your tenant and company data has been saved. Company setup will continue in the background.
          </p>

          <div
            class="mt-6 w-full max-w-md rounded-md border border-dashed border-[#cbd7e6] bg-[#f8fafc] p-5 text-left text-xs text-[#516785] dark:border-[#253b5c] dark:bg-[#111c2d] dark:text-white-dark"
          >
            <p class="leading-6">
              Our administrators will manually verify the credentials submitted for
              <strong class="text-[#163154] dark:text-white">{{ tenantForm.controls.companyName.value }}</strong
              >. Once the setup process is complete, a notification email will be sent to the email address you provided.
            </p>
            <div class="mt-4 flex items-center justify-between border-t border-[#dce4ee] pt-4 dark:border-[#253b5c]">
              <span class="text-[10px] font-extrabold uppercase tracking-wide text-[#8a9ab4]">Reference ID</span>
              <span class="font-mono text-sm font-extrabold text-[#9a0000]">{{ registrationReference }}</span>
            </div>
          </div>

          <div class="mt-6 flex flex-col gap-3 sm:flex-row">
            <a routerLink="/login" class="tenant-btn tenant-btn-secondary justify-center px-7">
              <i class="fa fa-arrow-left"></i>
              Back to Login
            </a>
            <button type="button" class="tenant-btn bg-[#163154] px-7 text-white hover:bg-[#07182f]" (click)="registerAnother()">
              <i class="fa fa-rotate-right"></i>
              Register Another Account
            </button>
          </div>
        </div>
        } @if (!registrationSubmitted) {
        <div class="mt-8 border-t border-[#dce4ee] pt-6 dark:border-[#253b5c]">
          @if (submitError) {
          <p class="mb-4 rounded-md border border-[#f0d5d5] bg-[#fff7f7] px-3 py-2 text-sm font-bold text-[#9a0000]">
            {{ submitError }}
          </p>
          }
          <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <button type="button" class="tenant-btn tenant-btn-secondary min-w-[126px] justify-center" (click)="currentStep === 1 ? cancel() : previousStep()">
              {{ currentStep === 1 ? 'Cancel' : 'Back' }}
            </button>
            <button type="submit" class="tenant-btn tenant-btn-primary login-form min-w-[150px] border-0" [disabled]="isSubmitting || isCheckingEmail">
              {{ submitButtonLabel }}
              <i
                class="fa"
                [ngClass]="isSubmitting || isCheckingEmail ? 'fa-spinner fa-spin' : currentStep === steps.length ? 'fa-cloud-upload-alt' : 'fa-arrow-right'"
              ></i>
            </button>
          </div>
        </div>
        }
      </form>
    </div>
  </div>
</section>
